import type { Level } from '../../schema/row-types.ts';
import type {
  RowOrderBy,
  RowQuery,
  SqliteQueryOptions,
} from '../../types/query.ts';
import { levels } from '../../schema/tables/gtfs-schedule/levels.ts';
import { findRows } from '../sqlite-query.ts';

/**
 * Returns an array of all levels that match the query parameters.
 * @param query Column values to match, as single values or arrays
 * @param fields Columns to select, or every column when empty
 * @param orderBy Column and direction pairs to sort by
 * @param options Query options, including the database to read from
 * @returns Matching rows, containing only `fields` when it is not empty
 */
export function getLevels<Fields extends keyof Level>(
  query: RowQuery<Level> = {},
  fields: readonly Fields[] = [],
  orderBy: RowOrderBy<Level> = [],
  options: SqliteQueryOptions = {},
) {
  return findRows<Level, Fields>(levels, query, fields, orderBy, options);
}
